import React, { useCallback } from 'react'
import Icon from '@/components/Icon'
import { Popover } from '@/components/popover'
import { useLocalization } from '@/hooks/localization'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { preventAndStop } from '@/components/report-tables/core/utils'
import { truncate } from '@/utils/StringUtilities'
import { reportPopOverMaxTextLength } from '@/utils/constants'

export function BasicCellButtons ({ info, warnings, errors }) {
  const { localize } = useLocalization()
  const viewWarning = useCallback(() => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.alert,
      title: 'Common.Warning',
      content: localize(warnings)
    }))
  }, [localize, warnings])
  const viewError = useCallback(() => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.alert,
      title: 'Common.Error',
      content: localize(errors)
    }))
  }, [localize, errors])
  return (
    <React.Fragment>
      {info && <span className='cell-btn'><Icon name='info-circle' /></span>}
      {warnings && <Popover placement='left' content={truncate(localize(warnings), reportPopOverMaxTextLength)}>
        <span onClick={viewWarning} onMouseDown={preventAndStop} className='cell-btn orange'><Icon name='help-circle' /></span>
      </Popover>}
      {errors && <Popover placement='left' content={truncate(localize(errors), reportPopOverMaxTextLength)}>
        <span onClick={viewError} onMouseDown={preventAndStop} className='cell-btn red'><Icon name='error-circle' /></span>
      </Popover>}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/report-tables/renderers/cellButtons/basicButtons.js